var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.229 6.67125L6.69279 3.26839C6.43175 3.10786 6.12829 3.01573 5.81485 3.00184C5.5014 2.98795 5.18976 3.05283 4.91321 3.18953C4.63667 3.32624 4.40563 3.52963 4.24479 3.77798C4.08394 4.02633 3.99933 4.31029 4 4.59953V11.4037C3.99996 11.6926 4.08502 11.9762 4.24612 12.2241C4.40722 12.472 4.63831 12.6749 4.91474 12.8112C5.19117 12.9475 5.50257 13.0121 5.81571 12.9981C6.12885 12.9841 6.43199 12.892 6.69279 12.7316L12.229 9.32875C12.4662 9.18299 12.6606 8.98552 12.7951 8.75386C12.9296 8.52221 13 8.26354 13 8.0008C13 7.73806 12.9296 7.47939 12.7951 7.24773C12.6606 7.01608 12.4662 6.81701 12.229 6.67125Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayOutline);
export default __webpack_public_path__ + "static/media/PlayOutline.5b4c2aaee084e87fc7fd9e2281882e9e.svg";
export { ForwardRef as ReactComponent };